var $e5a01f2966bf0b9a$exports = {};
$e5a01f2966bf0b9a$exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};


export {$e5a01f2966bf0b9a$exports as default};
//# sourceMappingURL=he-IL.module.js.map
